import React from 'react'
import SbEditable from 'storyblok-react'

import Components from './../Components'

import styles from './styles.module.scss'

const Grid = (props) => {
    return (
        <SbEditable content={props.blok}>
            <section className={styles['grid']}>
                {props.blok.vertical_title && <span className={'section-title'}>{props.blok.title}</span>}
                <div className='container'>
                    <ul className={styles['grid__list']} style={{ gridTemplateColumns: `repeat(3, 1fr)`, gridGap: `${props.blok.space_between / 10}rem` }}>
                        {props.blok.grid_items.map(blok => {
                            return (
                                <SbEditable content={blok} key={blok._uid}>
                                    <li className={styles['grid__item']}>
                                        {React.createElement(Components(blok.component), {
                                            key: blok._uid,
                                            blok: blok
                                        })}
                                    </li>
                                </SbEditable>
                            )
                        })}
                    </ul>
                </div>
            </section>
        </SbEditable>
    )
}

export default Grid
